/** Mga card sa Settings › Privacy na idinagdag ng M29: redaction, identity binding, egress, webhooks, retention, audit. Shell created by WP-M29-SCHEMA1: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const privacyM29 = {
  redaction: {
    title: "Takpan bago ang AI",
    intro: "Tinatakpan ang personal na data bago makarating ang mensahe sa AI model: sagot sa chat, pagpili ng tool, draft, ticket intake, buod at salin.",
    enforced: "Ipinapatupad",
    off: "Patay",
    kindsLabel: "Mga uri ng personal na data",
    kinds: {
      mobile: { label: "Mobile number", hint: "09171234567, +63 917 123 4567" },
      email: { label: "E-mail address", hint: "juan@example.ph" },
      national_id: { label: "National ID (PhilSys)", hint: "PhilID card at PhilSys number" },
      address: { label: "Address", hint: "Kalye, barangay, block at lot" },
      card_bank: { label: "Card at bank number", hint: "Card (sinusuri sa Luhn), bank account, IBAN" },
      gov_id: { label: "Government ID number", hint: "TIN, SSS, UMID, PhilHealth, Pag-IBIG, passport, driver's license" },
    },
    allOff: "Patay ang lahat ng uri dito. Ang assistant na may sariling pili sa Guardrails ay patuloy na magma-mask ng mga ito; ang iba ay nakatatanggap ng mensahe nang eksakto kung paano ito tinype ng customer.",
    agentNote: "Mas nangingibabaw ang sariling pili ng assistant sa Guardrails kaysa sa listahang ito; ang walang sariling pili ay sumusunod dito. Ang mga bagong assistant ay nagsisimula nang bukas ang lahat ng uri.",
    previewTitle: "Preview: ang natatanggap ng AI",
    previewInput: "Subukan ang isang mensahe",
    previewPlaceholder: "Mag-type ng mensaheng may phone number, e-mail o ID number",
    previewLimit: "{{used}} sa {{max}} na karakter",
    previewTooLong: "Hanggang {{max}} karakter lang ang puwede sa isang mensahe. Paikliin ito para makita ang natatanggap ng AI.",
    previewSample: "Hindi pumasok yung 500 sa account 0012 3456 7890. Tawagan niyo ako sa 09171234567 / juan@x.ph",
    previewLoading: "Tinatakpan ang mensahe…",
    previewNothing: "Walang natakpan sa mensaheng ito sa mga piniling uri.",
    previewEmpty: "Mag-type ng mensahe para makita ang natatanggap ng AI.",
    masked_one: "{{count}} value ang natakpan",
    masked_other: "{{count}} value ang natakpan",
    previewFailedTitle: "Hindi nag-load ang preview",
    previewFailedBody: "Ligtas ang iyong settings. Subukan ulit ang preview.",
    noAssistantTitle: "Gumawa ng assistant para sa preview",
    noAssistantBody: "Tumatakbo ang preview sa server gamit ang parehong patakaran ng AI gateway. Gawin ang una mong assistant para ito subukan.",
    noAssistantAction: "Gumawa ng assistant",
    save: "I-save ang redaction",
    saved: "Na-save ang redaction settings",
    readOnlyNote: "Makikita mo ang mga setting na ito pero hindi mo mababago.",
  },
  binding: {
    title: "Ang lookup ay para sa na-verify na customer",
    intro: "Kapag tinitingnan ng assistant ang account ng customer, ang customer na naka-sign in ang tinatanong nito, hindi ang pangalang nabanggit sa chat.",
    badge: "Nakatali sa session",
    lockedTitle: "Naka-lock sa session ang mga identity field",
    lockedBody: "Ang reference, tier at status ng account sa isang lookup ay galing sa na-verify na session. Hindi ito nakikita ng AI model bilang input at hindi mababago ng customer sa pagta-type.",
    liveLabel: "Mga lookup sa nakaraang 30 araw",
    count_one: "{{count}} lookup, lahat para sa customer sa session",
    count_other: "{{count}} lookup, lahat para sa customer sa session",
    countMore: "Hindi bababa sa {{count}} lookup, lahat para sa customer sa session",
    latest: "Huling lookup {{when}}",
    noneTitle: "Wala pang lookup",
    noneBody: "Kapag tiningnan ng assistant ang account ng naka-sign in na customer, nakatala rito ang bawat lookup.",
    viewLog: "Buksan ang lookup log",
    needsAudit: "Bukas ang lookup log sa mga miyembrong puwedeng tumingin ng audit log.",
    failedTitle: "Hindi na-load ang lookup activity",
    failedBody: "Walang binago. Subukan ulit sa ilang saglit.",
  },
  egress: {
    title: "Mga outbound IP address",
    intro: "I-allow ang mga ito sa firewall ninyo para sa mga tawag ng connector. Sinusuportahan din ng mga tawag ang mutual TLS, OAuth 2.0 client credentials at HMAC signing.",
    status: { healthy: "Maayos", degraded: "May problema", unconfigured: "Hindi pa naka-set up" },
    listLabel: "Mga outbound IP address",
    region: "Rehiyon {{region}}",
    copyAll: "Kopyahin lahat",
    copyOne: "Kopyahin ang {{address}}",
    copiedAll: "Nakopya ang mga IP address",
    copiedOne: "Nakopya ang {{address}}",
    verified: "Huling na-verify {{when}}",
    neverVerified: "Hindi pa na-verify",
    degradedTitle: "Hindi sumasagot ang fixed-IP path",
    degradedBody: "Naka-pause ang mga connector na may markang \"requires fixed IP\" hanggang bumalik ito, kaya walang tawag na lalabas sa ibang address. Patuloy na sumusubok ang ibang connector. Tumitingin kami ulit kada ilang segundo.",
    webhooksOff: "Hindi lumalabas sa mga address na ito ang mga webhook delivery. Naka-sign ang mga ito, kaya tingnan ang Sagot-Signature header sa halip na ang source address.",
    webhooksOn: "Lumalabas din sa mga address na ito ang mga webhook delivery.",
    emptyTitle: "Wala pang fixed IP address",
    emptyBody: "Hindi pa naka-on ang fixed outbound address sa environment na ito, kaya nagbabago ang address na pinanggagalingan ng mga tawag ng connector. Hilingin sa Sagot contact ninyo na i-on ito bago ninyo kami i-allow.",
    recheck: "Tingnan ulit",
    failedTitle: "Hindi na-load ang mga IP address",
    failedBody: "Walang binago. Subukan ulit sa ilang saglit.",
  },
  webhooks: {
    title: "May customer reference ang mga webhook",
    intro: "May lagda ng Sagot-Signature. Manipis ang mga event: mga ID at ang reference na gamit na ng inyong mga sistema.",
    sampleLabel: "Halimbawa ng webhook event",
    carries: "May customer_ref ang mga event ng conversation, mensahe at ticket. Null ito para sa anonymous na bisita.",
    active_one: "{{count}} aktibong webhook ang tumatanggap ng customer_ref",
    active_other: "{{count}} aktibong webhook ang tumatanggap ng customer_ref",
    noneActive: "Wala pang aktibong webhook na tumatanggap ng customer_ref. Buksan ang webhook na nakikinig sa mga event ng conversation, mensahe o ticket.",
    manage: "Ayusin ang mga webhook",
    emptyTitle: "Wala pang webhook",
    emptyBody: "Magdagdag ng webhook para magpadala ng may-lagdang event sa sarili ninyong mga sistema. May customer_ref ang mga ito para maitugma sa inyong mga customer.",
    emptyAction: "Magdagdag ng webhook",
    needsView: "Makikita rito ng mga miyembrong nag-aayos ng webhook kung aling endpoint ang tumatanggap ng reference.",
    failedTitle: "Hindi na-load ang mga webhook",
    failedBody: "Walang binago. Subukan ulit sa ilang saglit.",
  },
  retention: {
    title: "Retention ayon sa uri ng data",
    intro: "Gaano katagal itinatago ang bawat uri ng data. Sabay-sabay na itinatakda ng preset ang lahat; pinipigilan ng legal hold ang gabi-gabing purge sa uring iyon hanggang alisin ninyo.",
    presetLabel: "Preset",
    presets: {
      standard: { name: "Standard", body: "Chat 1 taon, ticket 5 taon, history ng customer 1 taon, security record 2 taon." },
      aml_5_years: { name: "AML 5 taon", body: "Chat, ticket, history ng customer at security record sa loob ng 5 taon, para sa record keeping laban sa money laundering." },
    },
    custom: "Pasadyang settings",
    customBody: "Isa-isang inedit ang mga settings na ito.",
    classLabel: "Uri ng data",
    keepLabel: "Itinatago nang",
    holdLabel: "Legal hold",
    holdOn: "Legal hold sa {{name}}",
    classes: {
      chats: { name: "Chat", hint: "Mga mensahe, sipi at rating ng mga conversation" },
      tickets: { name: "Ticket", hint: "Mga saradong ticket kasama ang mga mensahe at file" },
      customer_context_history: { name: "History ng customer", hint: "Mga pagbabago sa tier at status na ipinadala ng inyong mga sistema" },
      launch_sessions: { name: "Launch session", hint: "Mga secure launch, binubura 7 araw matapos matapos" },
      audit_security: { name: "Security at audit record", hint: "Mga launch, lookup, view at pagbabago sa key" },
    },
    fixed: "Nakatakda",
    years_one: "{{count}} taon",
    years_other: "{{count}} taon",
    days_one: "{{count}} araw",
    days_other: "{{count}} araw",
    floorNote: "Sa preset na ito, walang assistant na magbubura ng chat nang mas maaga sa {{days}} araw, kahit may sarili itong setting.",
    auditNote: "Append-only ang security at audit record: itinatago ang mga ito nang hindi bababa sa haba na ito at hindi kailanman binubura ng gabi-gabing job.",
    review: "Suriin ang mga pagbabago",
    noChanges: "Walang ilalapat: tugma na ang mga settings.",
    dialog: {
      title: "Suriin ang mga pagbabago sa retention",
      intro: "Ito ang mga pagbabagong gagawin nito. Itinatala sa audit log ang paglalapat.",
      colClass: "Uri ng data",
      colChange: "Pagbabago",
      from: "mula {{from}}",
      to: "tungo {{to}}",
      holdOn: "Naka-on ang legal hold: walang buburahin sa uring ito",
      holdOff: "Inalis ang legal hold",
      shorter: "Mas maikli: buburahin sa susunod na gabi-gabing purge (04:00) ang data na mas luma sa bagong tagal.",
      longer: "Mas mahaba: walang buburahin nang mas maaga.",
      empty: "Walang pagbabago",
      confirm: "Ilapat ang mga pagbabago",
      failed: "Hindi mailapat ang mga pagbabago",
    },
    applied: "Nailapat ang mga setting ng retention",
    needsManage: "Matitingnan ninyo ang mga settings na ito pero hindi mababago.",
    ticketsNeedDesk: "Sumusunod ang ticket sa Service Desk. I-set up muna ito bago baguhin ang retention ng ticket.",
    failedTitle: "Hindi na-load ang mga setting ng retention",
    failedBody: "Walang binago. Subukan ulit sa ilang saglit.",
  },
  audit: {
    title: "Security activity",
    intro: "Mga launch, lookup, view at pagbabago sa key. Tamper-evident; i-export para sa mga regulator.",
    subtitle: "Bawat pagbabagong ginawa sa workspace na ito. Tamper-evident at append-only.",
    trailLabel: "Ipakita",
    trails: { all: "Lahat ng aktibidad", launch: "Mga launch", customer: "Mga customer", api_key: "Mga API key" },
    events: {
      launch_minted: "Nagawa ang launch",
      launch_redeemed: "Nagamit ang code",
      launch_refused: "Tinanggihan ang launch",
      launch_revoked: "Binawi ang launch",
      customer_context_updated: "Na-update ang context ng customer",
      customer_lookup: "Lookup na nakatali sa session",
      customer_viewed: "Tiningnan ang record ng customer",
      customer_reference_revealed: "Ipinakita ang reference ng customer",
      api_key_allowlist_changed: "Nabago ang allowlist ng API key",
      api_key_signing_changed: "Nabago ang signing ng API key",
      api_key_ip_refused: "Tinanggihan ang API key: hindi pinapayagan ang address",
      api_key_rotated: "Napalitan ang API key",
      retention_preset_applied: "Nailapat ang mga setting ng retention",
    },
    exportCsv: "I-export ang CSV",
    exporting: "Inihahanda ang CSV…",
    exported: "Na-download ang CSV",
    exportFailed: "Hindi ma-download ang CSV",
    emptyTitle: "Wala pang security activity",
    emptyBody: "Lalabas dito ang mga launch, lookup at view ng customer, at pagbabago sa API key habang nangyayari.",
    viewAll: "Buksan ang buong audit log",
    needsView: "Makikita rito ng mga miyembrong puwedeng tumingin ng audit log ang mga launch, lookup at view.",
    failedTitle: "Hindi na-load ang security activity",
    failedBody: "Walang binago. Subukan ulit sa ilang saglit.",
    colTime: "Oras",
    colEvent: "Event",
  },
};
